/**
 * v-private: the element shows something privacy mode masks (D-260). `v-private="false"` for a
 * value that is not (the directive's place kept, the decision made by the field).
 */
function mark(el, binding) {
  if (binding.value === false) el.removeAttribute('data-private')
  else el.setAttribute('data-private', '')
}

export const vPrivate = { mounted: mark, updated: mark, getSSRProps: () => ({}) }
